import { Card, Layout, Paragraph } from '@vwfs-bronson/bronson-react';
type HomeViewProps = {
  onNavigate: (path: string) => void;
};

const destinations: Array<{
  path: string;
  title: string;
  description: string;
  icon: string;
}> = [
  {
    path: '/chat?new=1',
    title: 'Start a chat',
    description: 'Open a conversation with an agent in your team context.',
    icon: 'semantic-chat',
  },
  {
    path: '/agents/new',
    title: 'Create an agent',
    description: 'Configure a reusable agent and attach the skills it needs.',
    icon: 'semantic-user',
  },
  {
    path: '/jobs',
    title: 'Monitor jobs',
    description: 'Review execution status, source, ownership, and recent activity.',
    icon: 'semantic-performance',
  },
  {
    path: '/schedules',
    title: 'Manage schedules',
    description: 'Create and maintain recurring agent runs.',
    icon: 'semantic-calendar',
  },
];

export function HomeView({ onNavigate }: HomeViewProps) {
  return (
    <Layout equalHeight className="app-home-grid">
      {destinations.map(destination => (
        <Layout.Item default="1/2" s="1/1" key={destination.path}>
          <Card
            {...{ href: destination.path }}
            aria-label={destination.title}
            className="app-home-destination"
            element="a"
            icon={destination.icon}
            onClick={event => {
              if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
                return;
              }

              event.preventDefault();
              onNavigate(destination.path);
            }}
            title={destination.title}
          >
            <Paragraph>{destination.description}</Paragraph>
          </Card>
        </Layout.Item>
      ))}
    </Layout>
  );
}
